import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { LeavesService } from '../../services/leaves.service';

import * as moment from 'moment';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { Users } from 'src/app/modules/users/models/users';

import { LEAVES_SESSIONS } from '../../../../shared/constants/leave-sessions.constants';
import { LeaveTypesService } from 'src/app/modules/leave-type/services/leave-types.service';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-leave-create',
  templateUrl: './leave-create.component.html',
  styleUrls: ['./leave-create.component.css']
})
export class LeaveCreateComponent implements OnInit {

 /** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
 @ViewChild('myForm', {static: false}) myForm: NgForm;

 public leaveForm:FormGroup;

 public hasRole:string = this.authservice.hasRole();
 public orgId:string = this.authservice.getOrgId();
 public user_details:any = this.authservice.getUserDetails();
 public users:Users[];
 public applied_to:Users[];
 public leaveTypes:any;
 public usersReport:any;
 public availableLeaves:string = '';

 public USERS_LIST:Users[];

 public leave_sessions= LEAVES_SESSIONS;

 public isShowAlert:boolean= false;
 public isShowUsers:boolean = false;

 public fromMaxDate:Date;
 public fromMinDate:Date;
 public toMaxDate:Date;
 public toMinDate:Date;

 public searchUserNameCtrl = new FormControl('',Validators.required);

 constructor(private fb:FormBuilder,
   private dialog: MatDialog,
   private authservice:AuthenticationService,
   private organizationService:OrganizationAdminService,
   private leaveService:LeavesService,
   private userService:UsersService,
   private leaveTypeService:LeaveTypesService

   ) { }

 ngOnInit(): void {
   this.createleaveForm();
  //  this.setMinAndMaxValues();

  this.searchUserName();
   setTimeout(()=>{
      this.getLeaveTypes();
       this.getUsers();
       this.getReportingList();

   })
 }

 checkAuthenticationType():void{
    if(this.hasRole == '2'){
        this.isShowUsers = true;
        this.leaveForm.get("user_id").setValidators([Validators.required]);
        this.leaveForm.get("user_id").updateValueAndValidity();
    }else if(this.hasRole == '3' || this.hasRole == '4'){
        this.isShowUsers =false;
        let user_id = this.user_details.user_id || null;
        this.leaveForm.get("user_id").patchValue(user_id);
        this.getReportedToUsers(user_id);
    }
 }

 getLeaveTypes():void{
  // let filterParams = this.addFilterParameters();
  // console.log(filterParams);
   this.leaveTypeService.getLeaveTypes().subscribe(
     (res:any)=>{
       this.leaveTypes = res.body;
     }
   )
 }
 
 getUsers(orgId:string=undefined):void{

  let filterParams ={}
  
  filterParams["sort"] = "-id";
  
  if(orgId != undefined){
    filterParams['filter[org_id]'] =orgId;
  }

  let searchParams = this.searchUserNameCtrl.value; 

  if( searchParams != '' && searchParams.length >= 3){
    filterParams['filter[name][like]'] = searchParams.trim();
  }

  this.userService.getUsersList(filterParams).subscribe(
      (res:any)=>{
        this.users = res.body;
        if(this.USERS_LIST == undefined || this.USERS_LIST.length == 0){
          this.USERS_LIST = res.body;
        }
        this.checkAuthenticationType();
      }
    );
  }

  getAvailableleaves(){

   let data = {
     org_id: this.orgId,
     user_id: this.leaveForm.value.user_id,
     leave_type: this.leaveForm.value.leave_type,
     date: this.leaveForm.value.leave_from.getFullYear()
   };


   this.leaveService.getAvailableLeaves(data).subscribe(
     (res:any)=> {
        this.availableLeaves= res;
     }
   );
  }

 createleaveForm(){
   this.leaveForm = this.fb.group({
    org_id	: [this.orgId],
    user_id:[''],
    leave_type:['',[Validators.required]],
    leave_from: ['',[Validators.required]],
    leave_to: ['',[Validators.required]],
    leave_days: ['',[Validators.required]],
    applied_to: [''],
    from_session: ['',[Validators.required]],
    to_session: ['',[Validators.required]],
    leave_reason:['']
   })
 }

 get leaveFormValidate(){
   return this.leaveForm.controls;
 }

 leaveFormSubmit():void{

   if(this.leaveForm.invalid){
     return;
   }

  //  console.log(this.leaveForm.value);

   this.leaveForm.patchValue({
     leave_from: moment(this.leaveForm.value.leave_from).format("YYYY-MM-DD"),
     leave_to: moment(this.leaveForm.value.leave_to).format("YYYY-MM-DD"),
   })

   this.leaveForm.get("leave_days").enable();
   this.leaveForm.get("leave_days").updateValueAndValidity();
   this.leaveService.createLeave(this.leaveForm.value).subscribe(
     (res)=>{
       this.leaveForm.reset();
       this.myForm.resetForm();
       this.isShowAlert= true;
       this.closeAlertMessage();
       this.createleaveForm();
      //  this.setMinAndMaxValues();
       this.availableLeaves = '';
       this.searchUserNameCtrl.reset("");
      //  this.checkAuthenticationType();
     }
   )
 }

 cancel():void{
   this.dialog.closeAll();
 }

 closeAlertMessage():void{
   setTimeout(()=>{
     this.isShowAlert=false;
   },5000);
 }

  setMinAndMaxValues():void{
    this.fromMinDate = new Date();
    this.toMinDate = new  Date();
  }

   /*** TO SET TO_DATE MINIMUN VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF FROM_DATE ***/
   onFromDateChange(event):void{
    this.toMinDate = event.target.value;
    this.leaveDays();
   
  }

  /*** TO SET FROM_DATE MAXIMUM VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF TO_DATE ***/
  onToDateChange(event):void{
    this.fromMaxDate = event.target.value;
    this.leaveDays();
  }

  leaveDays():void{
    let leave_from = this.leaveForm.value.leave_from;
    let leave_to = this.leaveForm.value.leave_to;
    let from_session = this.leaveForm.value.from_session;
    let to_session = this.leaveForm.value.to_session;

    if(leave_from !='' && leave_to != '' && from_session != '' && to_session != ''){

      let diffDays = this.DifferenceBitWeenTwoDays(this.leaveForm.value.leave_from,this.leaveForm.value.leave_to);
      let days = Math.abs(diffDays)+1;

      if(from_session === "2"){
       days = days - 0.5;
      }

      if(to_session === "1"){
        days = days - 0.5;
      }

      if(days == 0){
        alert(`Invalid! check your dates or sessions`);
        return;
      }

      this.getAvailableleaves();

      this.leaveForm.get("leave_days").setValue(days);
      this.leaveForm.get("leave_days").disable({ onlySelf: true });
      this.leaveForm.get("leave_days").updateValueAndValidity();
      
    }
  }

  DifferenceBitWeenTwoDays(from_date:any,to_date:any):number{
    let fromDate = moment(from_date, "DD/MM/YYYY");
    let toDate = moment(to_date, "DD/MM/YYYY");
    return fromDate.diff(toDate, 'days');
  }

  addFilterParameters():Object{
    let filterParams = {};
    filterParams["sort"] = "-id";
    filterParams['filter[org_id]'] = this.orgId;
    return filterParams;
  }

  getReportedToUsers(user_id:number|string):void{

    let selectedUser:Users = this.users.find(d=>{return d.id === user_id});//get selected user data

    let reported_to_user_ids = (selectedUser.reporting_to != undefined && selectedUser.reporting_to != null)? selectedUser.reporting_to.map(d=>d.reporting_to):[];//get reported user id's
  
    let removeDuplicateIds= Array.from(new Set(reported_to_user_ids));//remove duplicate elements

    //get reported users full data adde into applied_to field
    this.applied_to  = removeDuplicateIds.map(data=>{
      let result =this.USERS_LIST.find(user => user.id === data);
      return result;
    });

    if(this.applied_to.length == 0){
      this.applied_to = [selectedUser];
    }

    this.leaveForm.get("applied_to").setValidators([Validators.required])
    this.leaveForm.get("applied_to").updateValueAndValidity();

  }

  searchUserName(){
    this.searchUserNameCtrl.valueChanges
      .pipe(
        delay(300),
      )
      .subscribe(val=> {

        this.leaveForm.patchValue({
          'user_id': (this.searchUserNameCtrl.value != null )?this.searchUserNameCtrl.value.id:''
        });

        if(this.searchUserNameCtrl.value.id != undefined && this.searchUserNameCtrl.value.id != ''){
          this.getReportedToUsers(this.searchUserNameCtrl.value.id);
        }

        this.getUsers(this.orgId);
        this.getReportingList(this.searchUserNameCtrl.value.id);

      });
  }

  displaySearchUserName(users:Users) {
    if (users) { return users.name; }
  }
  getReportingList(userId:string=undefined):void{
    let filterParams ={}
  
  filterParams["sort"] = "-id";
  
  if(userId != undefined){
    filterParams['filter[user_id]'] =userId;
  }

    this.userService.getReportingList(filterParams).subscribe(
        (res:any)=>{
          this.usersReport = res.body;
          
      }
    )
  }

}
